"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentLoaderMediated = void 0;
const bus_http_1 = require("@comunica/bus-http");
const stream_to_string_1 = require("@jeswr/stream-to-string");
const jsonld_context_parser_1 = require("jsonld-context-parser");
/**
 * A JSON-LD document loader that fetches over an HTTP bus using a given mediator.
 */
class DocumentLoaderMediated extends jsonld_context_parser_1.FetchDocumentLoader {
    context;
    lastCachePolicies;
    cache;
    constructor(mediatorHttp, context, cache, lastCachePolicies = {}) {
        super(DocumentLoaderMediated.createFetcher(mediatorHttp, context, lastCachePolicies));
        this.context = context;
        this.lastCachePolicies = lastCachePolicies;
        this.cache = cache;
    }
    static createFetcher(mediatorHttp, context, lastCachePolicies) {
        return async (url, init) => {
            const response = await mediatorHttp.mediate({ input: url, init, context });
            if (response.cachePolicy) {
                lastCachePolicies[url] = (context) => response
                    .cachePolicy.satisfiesWithoutRevalidation({ input: url, init, context });
            }
            response.json = async () => JSON.parse(await (0, stream_to_string_1.stringify)(bus_http_1.ActorHttp.toNodeReadable(response.body)));
            return response;
        };
    }
    async load(url) {
        const cache = this.cache;
        if (cache) {
            const cached = cache.get(url);
            if (cached) {
                if (cached.isStillValid && await cached.isStillValid(this.context)) {
                    return cached.context;
                }
                cache.delete(url);
            }
        }
        const loaded = await super.load(url);
        this.cache?.set(url, { context: loaded, isStillValid: this.lastCachePolicies[url] });
        return loaded;
    }
}
exports.DocumentLoaderMediated = DocumentLoaderMediated;
//# sourceMappingURL=DocumentLoaderMediated.js.map